import {BaseApi} from '@/api/base.api.js'

/**
 * Auth API class
 */
export class AuthApi extends BaseApi {

  //Props
  basePath = '/api/v1'
  convertParamKeys = true
  convertDataKeys = true
  convertJsonKeys = true

  /**
   * Authenticate with MS Teams SSO token
   */
  authenticateWithTeamsSSOToken(token, userData = {}) {
    return this
      .post('/microsoft/authentication_tokens', {
        token,
        ...userData,
      })
  }

  /**
   * Get CSRF token from API endpoint
   */
  getCsrfToken() {
    return this
      .get('/csrf_token')
      .then(data => data.csrfToken)
  }
}

//Export singleton instance
export const authApi = new AuthApi()
